<div class="container mt-3">
  <div class="row text-center">
    <div class="col">
      <h1 *ngIf="isLoggedIn" class="text-center">
        Benvenuto {{ authService.userInfo.name }}
      </h1>
    </div>
  </div>

  <div class="row my-3" *ngIf="!isLoggedIn">
    <div class="col-auto">
      <it-callout
        [appearance]="'highlight'"
        [color]="'important'"
        [label]="'Accesso riservato'"
      >
        <p>
          L'accesso alla piattaforma è consentito esclusivamente agli utenti
          autorizzati, in possesso di credenziali personali. Tutte le attività
          eseguite sono tracciate a fini di sicurezza e conformità. L'utente è
          responsabile del corretto utilizzo delle credenziali di accesso e del
          trattamento dei dati secondo quanto previsto dalla normativa vigente
          in materia di protezione dei dati personali (GDPR). È severamente
          vietato qualsiasi accesso non autorizzato o utilizzo improprio del
          sistema. Ogni tentativo di violazione verrà registrato e potrà essere
          perseguito ai sensi di legge.
        </p>
      </it-callout>
    </div>
  </div>

  <div class="row text-center">
    <div class="col">
      <button
        class="mb-5"
        [itButton]="'primary'"
        [size]="'lg'"
        (click)="login()"
      >
        Accedi alla piattaforma
      </button>
    </div>
  </div>
</div>
